import { SET_FILE_CONTENT } from '../../constants';

const initialState = {
	fileContent: ''
};

const editorReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FILE_CONTENT:
			return {
				fileContent: action.payload
			};
		default:
			return state;
	}
};

export default editorReducer;
